import { FiAlertCircle, FiCheckCircle, FiPackage } from 'react-icons/fi';
import { useFoundItemCounts } from '../hooks/useFoundItems';

export function StatsCards() {
	const { data, isLoading } = useFoundItemCounts();
	const total = (data?.disponivel ?? 0) + (data?.devolvido ?? 0);

	const cards = [
		{ label: 'Total de itens', value: total, icon: FiPackage, color: 'text-gray-700' },
		{
			label: 'A procurar',
			value: data?.disponivel ?? 0,
			icon: FiAlertCircle,
			color: 'text-amber-600',
		},
		{
			label: 'Devolvidos',
			value: data?.devolvido ?? 0,
			icon: FiCheckCircle,
			color: 'text-green-600',
		},
	];

	return (
		<div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
			{cards.map((c) => (
				<div
					key={c.label}
					className="p-4 bg-white border border-gray-200 rounded-lg flex items-center gap-3"
				>
					<c.icon size={24} className={c.color} />
					<div>
						<p className="text-sm text-gray-500">{c.label}</p>
						<p className="text-xl font-semibold text-gray-900">{isLoading ? '…' : c.value}</p>
					</div>
				</div>
			))}
		</div>
	);
}
